export default __webpack_public_path__ + "static/muddle-782061c71c66c41856e7ea0f694988a1.png";